import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { inject, Component, Input, Output, EventEmitter } from '@angular/core';
import { ICart } from '@models/payment.model';
import { NgIf } from '@angular/common';
import { UtmWalletHundredComponent } from '../utm-wallet-hundred/utm-wallet-hundred.component';

@Component({
  selector: 'app-paytm',
  templateUrl: './paytm.component.html',
  styleUrls: ['./paytm.component.scss'],
  standalone: true,
  imports: [NgIf, UtmWalletHundredComponent]
})
export class PaytmComponent {

  public paymentUtil = inject(PaymentUtilService);

  @Input() option;
  @Input() cartDetails: ICart;
  @Input() isOrderLoading;
  @Input() qrCodeUrl;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();


  /**On click event of payment */
  submitPayTm() {
    const data = {
      'mode': 'PAYTM',
      'mode_value': 'PAYTM',
    };
    this.dataEmit.emit(data);
  }

}
